import React from 'react';
import Logo from '../Logo/Logo'
import Navigations from '../Navigations/Navigations';
import MyHeader from "./Header.module.css";
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { ShareModal } from '../ShareModal/ShareModal';
import DocumentMembers from '../Members/members';
import Modes from './modes';
import CompleteDocument from '../CompleteDoc/completeDoc';
import publicIcon from '../../assets/world.svg';
import privateIcon from '../../assets/lock.svg';
import SavingStatus from '../SavingStatus/savingStatus ';
import { Tooltip } from 'antd';
import TemplateActiveToggle from '../TemplateActiveToggle';
import TemplateThumbnail from '../TemplateThumbnail';
import DocumentTitle from '../DocumentTitle/DocumentTitle';
import HeaderAvatar from '../Avatar/HeaderAvatar';
import AppLauncherModal from '../AppLauncher/AppLauncherModal';
import OfflineToggle from '../OfflineToggle';
import { Tooltip as AntTooltip } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { useFullView, useFullViewShortcut } from '../../utils/fullView';
import HeaderMenu from './HeaderMenu';


/**
 * One 56px bar, laid out like Sheets: the logo, then the title over a second
 * line that carries the File / Edit / Insert / View menus and the saved
 * status, then the actions on the right. Full view (the chevron tab that
 * hangs below the bar, View > Full view, Ctrl+Shift+F) hides the bar so the
 * grid gets the height back. Same controls as before, same order.
 */
const Header = ({ fileDisplay }) => {
    const { documentInfo, isReadOnly, userInfo, isTemplateDocument } = useDocument();
    const [fullView, toggleFullView] = useFullView();
    useFullViewShortcut();
    return (
        <div id='myy-header' className={MyHeader.header}>
            <div className={MyHeader.topBar}>
                <Logo />
                <div className={MyHeader.titleBlock}>
                    <div className={MyHeader.titleRow}>
                        <DocumentTitle alreadyAligned={fileDisplay} documentInfo={documentInfo} />
                        {!isTemplateDocument && (
                            documentInfo?.privacyId == 2 ? (
                                <Tooltip title='Private documnet'>
                                    <img src={privateIcon} alt='Private documnet' style={{ width: '12px' }} />
                                </Tooltip>
                            ) : (
                                <Tooltip title='Public documnet' >
                                    <img src={publicIcon} alt='Public documnet' style={{ width: '15px' }} />
                                </Tooltip>
                            )
                        )}
                        {!isReadOnly && !isTemplateDocument && <CompleteDocument />}
                    </div>
                    <div className={MyHeader.statusRow}>
                        {fileDisplay && <Navigations />}
                        {fileDisplay && <span className={MyHeader.statusDivider} />}
                        <SavingStatus />
                    </div>
                </div>
                <div className={MyHeader.spacer} />
                {/* Every control is sized to 30px natively (see .actions in the
                    CSS) rather than shrunk with a transform, so the gaps are real.
                    Share is the one primary; a hairline sets off the account cluster. */}
                <div className={MyHeader.actions}>
                    {!isTemplateDocument && !isReadOnly && <OfflineToggle />}
                    {!isTemplateDocument && !isReadOnly && <span className={MyHeader.actionsDivider} aria-hidden="true" />}
                    {!isTemplateDocument && <DocumentMembers />}
                    {documentInfo?.createBy == userInfo.userId && !isTemplateDocument && <ShareModal />}
                    {isTemplateDocument && <TemplateActiveToggle />}
                    {isTemplateDocument && <TemplateThumbnail />}
                    <span className={MyHeader.actionsDivider} aria-hidden="true" />
                    <AppLauncherModal />
                    {documentInfo && <Modes />}
                    <HeaderAvatar scale={1} />
                    {/* Small screens (see the CSS): the controls above give way to a
                        hamburger carrying the same actions, then the avatar. */}
                    <div className={MyHeader.compact}>
                        <HeaderMenu />
                        <HeaderAvatar scale={1} />
                    </div>
                </div>
            </div>
            <AntTooltip title={fullView ? 'Show header' : 'Full view (Ctrl+Shift+F)'} placement="left">
                <button
                    type="button"
                    className={MyHeader.fullViewToggle}
                    onClick={toggleFullView}
                    aria-label={fullView ? 'Show header' : 'Full view'}
                    aria-pressed={fullView}
                >
                    {fullView ? <DownOutlined /> : <UpOutlined />}
                </button>
            </AntTooltip>
        </div>
    )
};
export default Header;
